const getAdminToken = () => localStorage.getItem('adminToken');

const fetchWithAuth = async (url, options = {}) => {
  const token = getAdminToken();
  const res = await fetch(url, {
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...(token && { Authorization: `Bearer ${token}` }),
      ...options.headers,
    },
  });
  const data = await res.json();
  if (!res.ok) throw new Error(data.message || 'เกิดข้อผิดพลาด');
  return data;
};

export const adminUsersAPI = {
  getAll: () => fetchWithAuth('/api/admin-users'),
  create: (body) => fetchWithAuth('/api/admin-users', { method: 'POST', body: JSON.stringify(body) }),
  update: (id, body) => fetchWithAuth(`/api/admin-users/${id}`, { method: 'PUT', body: JSON.stringify(body) }),
  delete: (id) => fetchWithAuth(`/api/admin-users/${id}`, { method: 'DELETE' }),
};
